module.exports = __webpack_public_path__ + "img/kislovodsk-trips.a644e970.jpg";